<div class="main" [class.main--overlay]="overlayMode">
  <div class="incluir-contenido__header">
    <h2>Incluir contenido</h2>
    <button *ngIf="overlayMode"
            type="button"
            class="incluir-contenido__close"
            id="cerrarTiposContenidoId"
            aria-label="Cerrar"
            (click)="solicitarCierre()">
      <svg class="icon-close">
        <use xlink:href="#icon-close"></use>
      </svg>
    </button>
  </div>
  <div class="incluir-contenido__body" [class.incluir-contenido__body--overlay]="overlayMode">
    <p class="incluir-contenido__intro">Antes realizar el envío es posible definir campos de texto que se autorellenen, mediante el uso de palabras clave, con contenido específico en función de, p.ej. el firmante principal, fecha actual, etc.</p>
    <h6>Instrucciones</h6>
    <ol>
      <li>Arrastra las palabras clave al documento</li>
      <li>Emplázalas en el lugar deseado</li>
      <li>Ajusta la anchura del campo de texto</li>
    </ol>
    <h6 class="incluir-contenido__palabras-titulo">Palabras clave</h6>
    <div class="incluir-contenido__palabras">
      <div *ngIf="cargandoPalabras" class="incluir-contenido__palabras-loading">
        <mat-spinner diameter="30" strokeWidth="2"></mat-spinner>
      </div>
      <ng-container *ngIf="!cargandoPalabras">
        <app-contenido-doc *ngFor="let palabra of palabraMoverArray" [palabraClave]="palabra" [topPosition]="top" [leftPosition]="left"></app-contenido-doc>
        <app-configuracion-documento-palabra-clave *ngFor="let palabra of palabrasClave" [palabraClave]="palabra" (moverPalabra)="getPalabraAMover($event)"></app-configuracion-documento-palabra-clave>
      </ng-container>
    </div>
  </div>
  <div *ngIf="overlayMode" class="incluir-contenido__footer">
    <span id="volverTiposContenidoId" class="incluir-contenido__volver" (click)="solicitarCierre()">Volver</span>
  </div>
</div>

